/**
 * /my-coaching/accelerator — the Business Builder Accelerator's offer page,
 * behind `accelerator_sales`. The course card and the band in My assets link
 * here, and its checkout returns here. Without the flag, and for a revoked
 * coach, it goes to the dashboard.
 */

import { createFileRoute, redirect } from "@tanstack/react-router";

import { AcceleratorOfferPage } from "~/components/accelerator/accelerator-offer-page";
import { isFeatureFlagOn } from "~/lib/feature-flags/route";
import { acceleratorQueryOptions } from "~/lib/queries/acceleratorQuery";

export const Route = createFileRoute("/_user/my-coaching/accelerator")({
  staticData: { title: "Business Builder Accelerator" },
  beforeLoad: async ({ context }) => {
    if (
      context.isRevoked ||
      !(await isFeatureFlagOn(context.queryClient, "accelerator_sales"))
    ) {
      throw redirect({ to: "/my-coaching/clients/dashboard" });
    }
  },
  loader: async ({ context }) => {
    // Hands SSR the offer. A failed read is the page's own retry, never the
    // router's error page.
    await context.queryClient
      .ensureQueryData(acceleratorQueryOptions())
      .catch(() => undefined);
  },
  component: AcceleratorOfferPage,
});
